import { render, staticRenderFns } from "./OpeningTimeChanger.vue?vue&type=template&id=57013d7a&scoped=true"
import script from "./OpeningTimeChanger.vue?vue&type=script&lang=js"
export * from "./OpeningTimeChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57013d7a",
  null
  
)

export default component.exports